<template>
  <div class="week-select">
    <b-modal :active.sync="showDatepicker">
      <div class="box">
          <b-datepicker icon-pack="fa" v-model="datePickerDate" inline></b-datepicker>
      </div>
    </b-modal>
    <div class="field is-grouped">
      <p class="control">
        <button class="button prev-week-button" @click="prevWeek">
          <i class="fa fa-arrow-left"></i>
        </button>
      </p>
      <p class="control">
        <button class="button current-week-button" @click="showDatepicker = true">
          <span class="icon is-small">
            <i class="far fa-calendar-alt"></i>
          </span>
          <span>{{ weekStartingStr }}</span>
        </button>
      </p>
      <p class="control">
        <button class="button next-week-button" @click="nextWeek">
          <i class="fa fa-arrow-right"></i>
        </button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeekSelect',
  props: ['date'],
  data () {
    return {
      week: null,
      showDatepicker: false,
      datePickerDate: null
    }
  },
  computed: {
    weekStartingStr () {
      if (!this.week) return ''
      let format = this.$store.getters.isPhone ? 'ddd Do MMM YYYY' : 'dddd Do MMMM YYYY'
      return this.week.format(format)
    }
  },
  watch: {
    week () { this.$emit('week-changed', this.$moment(this.week)) },
    datePickerDate (date) {
      console.log(date)
      this.week = this.$moment(date).startOf('isoWeek')
      this.showDatepicker = false
    }
  },
  created () {
    this.week = this.$moment(this.date).startOf('isoWeek')
  },
  methods: {
    onClickDay (day) {
      this.week = day.startOf('isoWeek')
    },
    prevWeek () {
      this.week = this.$moment(this.week.add(-1, 'w'))
    },
    nextWeek () {
      this.week = this.$moment(this.week.add(1, 'w'))
    }
  }
}
</script>

<style>
.modal-content {
  width: auto;
}
</style>
